/* eslint-disable no-unused-vars */
import { ReactElement, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { startLoadUser, useAuthStore } from '../store/auth.store';
import { getAuthCookies } from '../cookies/auth.cookies';
import { startLoadWorkspace, useWorkspaceStore } from '../store/workspace.store';
import { getWorkspaceCookies } from '../cookies/workspace.cookies';
import { Loading } from '../components/Loading';

interface PrivateRouteProps {
  children: ReactElement;
}

const PrivateRoute = ({ children } : PrivateRouteProps) => {
    const {
        token: tokenCookie,
        userID: userIDCookie,
        mustAnswerQuestion: mustAnswerQuestionCookie,
    } = getAuthCookies();

    const {
        workspaceID: workspaceIDCookie,
    } = getWorkspaceCookies();

    const {
        data: user,
        mustAnswerQuestion,
        setMustAnswerQuestion,
    } = useAuthStore(
        useShallow((state) => ({
            data: state.data,
            mustAnswerQuestion: state.mustAnswerQuestion,
            setMustAnswerQuestion: state.setMustAnswerQuestion,
        })),
    );

    const { data: workspace, loading: workspaceLoading } = useWorkspaceStore(
        useShallow((state) => ({ data: state.data, loading: state.loading })),
    );

    const { pathname, search } = useLocation();

    useEffect(() => {
        if (mustAnswerQuestionCookie) setMustAnswerQuestion(mustAnswerQuestionCookie === 'true');
        if (!user && userIDCookie && tokenCookie) startLoadUser(tokenCookie);
    }, []);

    useEffect(() => {
        if (!user) return;
        if (!workspace && user) startLoadWorkspace();
    }, [user]);

    if (!user) {
        const url = `/login?redirect=${pathname + search}`;

        return <Navigate to={url} />;
    }
    if (!user?.mobile) return <Navigate to="/signup" />;
    if (mustAnswerQuestion && pathname !== '/about-you') return <Navigate to="/about-you" />;
    if (!workspace && (workspaceLoading || workspaceIDCookie)) return <Loading />;
    if (!workspace && !pathname.startsWith('/onboarding') && !mustAnswerQuestion) return <Navigate to="/onboarding/create-workspace" />;

    return children;
};

export { PrivateRoute };
